// extracted by mini-css-extract-plugin
export default {"logo":"YEx7Emv_wyjJ6A61at1z"};